import React, { Component } from "react";
import RouteMenu from "VENDOR/CommonResources/RoutingMenu/RouteMenu";
import "../vendorDashboard/VendorDashboard.scss";
import { connect } from "react-redux";
import config from "config";
import vendorApiCall from "vendorApiCall";
import greenInvoice from "../../CommonResources/greenInvoice.png";
import orangeInvoice from "../../CommonResources/orangeInvoice.png";
import blueInvoice from "../../CommonResources/blueInvoice.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  CartesianGrid
} from "recharts";
import Select from "react-select";

let apiPath = "/vendor/api/vendor.php";

class VendorDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quotation: { total: 0, pending: 0, requested: 0 },
      purchaseOrder: { total: 0, pending: 0, approved: 0 },
      isLoading: false,
      selectedStatus: "",
      quotationCost: 0,
      purchaseOrderCost: 0,
      delivery: 0,
      graph: [],
    };
  }

  componentDidMount() {
    this.fetchDashboardData();
    this.fetchDashboardDataGraph();
  }

  componentDidUpdate(prevProps) {
    if (
      (JSON.stringify(this.props.iidArray) != JSON.stringify(prevProps.iidArray)) ||  (JSON.stringify(this.props.iidDetails) != JSON.stringify(prevProps.iidDetails))
    ) {
      this.setState(
        {
          iidArray: this.props.iidArray,
        },
        () => {
          this.fetchDashboardData();
          this.fetchDashboardDataGraph();
        }
      );
    }
  }

  fetchDashboardData = async () => {
    try {
      this.setState({ isLoading: true });

      const vendorArray = Object.keys(this.props.iidDetails).map(iid => {
        const details = this.props.iidDetails[iid]?.details;
        return details?.vendorId || null;
      }).filter(Boolean);
  
      const requestData = {
        iidArray: this.props.iidArray,
        vendorId: config.instructorInfo.data.vendorId,
        vendorIdArray:vendorArray,
      };

      const response = await vendorApiCall.makeApiCall(
        "inventory_vendorDashoardCards",
        requestData,
        apiPath
      );

      const apiData = response?.APIResult?.data || {};
      this.setState({
        quotation: apiData.quotation || { total: 0, pending: 0, requested: 0 },
        purchaseOrder: apiData.purchaseOrder || {
          total: 0,
          pending: 0,
          approved: 0,
        },
        isLoading: false,
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      this.setState({ isLoading: false });
    }
  };

  fetchDashboardDataGraph = async () => {
    try {
      this.setState({ isLoading: true });
      const vendorArray = Object.keys(this.props.iidDetails).map(iid => {
        const details = this.props.iidDetails[iid]?.details;
        return details?.vendorId || null;
      }).filter(Boolean);
      const requestData = {
        iidArray: this.props.iidArray,
        vendorId: config.instructorInfo.data.vendorId,
        filter: this.state.selectedStatus,
        vendorIdArray:vendorArray,

      };

      const response = await vendorApiCall.makeApiCall(
        "inventory_vendor_DeliveryDashboard",
        requestData,
        apiPath
      );

      const apiData = response?.APIResult?.data || {};
      this.setState({
        isLoading: false,
        graph: apiData?.deliveryGraph,
        quotationCost: apiData?.deliveryCost?.totalCost,
        purchaseOrderCost: apiData?.deliveryCost?.totalBalance,
        delivery: apiData?.deliveryCost?.totalPaid,
        filter: this.state.selectedStatus,
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      this.setState({ isLoading: false });
    }
  };

  handleRedirect = (path,filterType) => {
    localStorage.setItem(`${path}_filter`, filterType);
    this.props.history.push(`/${path}`);
  };

  render() {
    const { quotation, purchaseOrder, isLoading } = this.state;

    const statusOptions = [
      { value: "today", label: "Today" },
      { value: "weekly", label: "Weekly" },
      { value: "monthly", label: "Monthly" },
      { value: "quarterly", label: "Quarterly" },
      { value: "year", label: "Year" },
      { value: "", label: "All" },
    ];
    return (
      <div className="vendor-dashboard">
        <RouteMenu />
        <div className="dashboard-container">
          {isLoading ? (
            <div className="loading">Loading...</div>
          ) : (
            <>
              <div className="dashboard-cards">
                {/* Top Row: Quotations */}
                <div className="row">
                  <div className="card blue">
                    <div className="card-header">
                      <div className="icon-container">
                        <img src={blueInvoice} alt="Blue Icon" />
                      </div>
                      <h4>
                        Total Quotation
                        <br />
                        Request
                      </h4>
                    </div>
                    <div className="card-footer">
                    <div className="d-flex">
                      <p className="count">{quotation.total}</p>
                      <span className="label">Quotation Request</span>
                    </div>
                      {/* <Link to="/quotations"> */}
                      <button onClick={() => this.handleRedirect( "quotations","")} style={{height:'35px'}}>
                          See All&nbsp;
                          <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                        </button>
                      {/* </Link> */}
                    </div>
                  </div>

                  <div className="card orange">
                    <div className="card-header">
                      <div className="icon-container">
                        <img src={orangeInvoice} alt="Orange Icon" />
                      </div>
                      <h4>
                        Pending Quotation
                        <br />
                        Request
                      </h4>
                    </div>
                    <div className="card-footer">
                      <div className="d-flex">
                        <p className="count">{quotation.pending}</p>
                        <p className="label">Quotation Request</p>
                      </div>
                      {/* <Link to="/quotations"> */}
                      <button onClick={() => this.handleRedirect( "quotations","pending")} style={{height:'35px'}}>

                          See All&nbsp;
                          <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                        </button>
                      {/* </Link> */}
                    </div>
                  </div>

                  <div className="card green">
                    <div className="card-header">
                      <div className="icon-container">
                        <img src={greenInvoice} alt="Green Icon" />
                      </div>
                      <h4>
                        Responded To
                        <br />
                        Quotation Request
                      </h4>
                    </div>
                    <div className="card-footer">
                    <div className="d-flex">
                      <p className="count">{quotation.shared}</p>
                      <span className="label">Quotation Responded</span>
                    </div>
                      {/* <Link to="/quotations"> */}
                      <button onClick={() => this.handleRedirect( "quotations","shared")} style={{height:'35px'}}>
                          See All&nbsp;
                          <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                        </button>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>

                {/* Bottom Row: Purchase Orders */}
                <div className="row">
                  <div className="card blue">
                    <div className="card-header">
                      <div className="icon-container">
                        <img src={blueInvoice} alt="Blue Icon" />
                      </div>
                      <h4>
                        Total Purchase
                        <br />
                        Order
                      </h4>
                    </div>
                    <div className="card-footer">
                    <div className="d-flex">
                      <p className="count">{purchaseOrder.total}</p>
                      <span className="label">Purchase Order</span>
                      </div>
                      {/* <Link to="/purchase-order"> */}
                      <button onClick={() => this.handleRedirect( "purchase-order","")} style={{height:'35px'}}>
                          See All&nbsp;
                          <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                        </button>
                      {/* </Link> */}
                    </div>
                  </div>

                  <div className="card orange">
                    <div className="card-header">
                      <div className="icon-container">
                        <img src={orangeInvoice} alt="Orange Icon" />
                      </div>
                      <h4>
                        Pending Purchase
                        <br />
                        Order
                      </h4>
                    </div>
                    <div className="card-footer">
                    <div className="d-flex">
                      <p className="count">{purchaseOrder.pending}</p>
                      <span className="label">Purchase Order</span>
                      </div>
                      {/* <Link to="/purchase-order"> */}
                      <button onClick={() => this.handleRedirect( "purchase-order","Generated")} style={{height:'35px'}}>
                          See All&nbsp;
                          <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                        </button>
                      {/* </Link> */}
                    </div>
                  </div>

                  <div className="card green">
                    <div className="card-header">
                      <div className="icon-container">
                        <img src={greenInvoice} alt="Green Icon" />
                      </div>
                      <h4>
                        Approved Purchase
                        <br />
                        Order
                      </h4>
                    </div>
                    <div className="card-footer">
                    <div className="d-flex">
                      <p className="count">{purchaseOrder.approved}</p>
                      <span className="label">Purchase Order</span>
                      </div>
                      {/* <Link to="/purchase-order"> */}
                      <button onClick={() => this.handleRedirect( "purchase-order","approve")} style={{height:'35px'}}>
                          See All&nbsp;
                          <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                        </button>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="dashboard-charts">
                <div className="chart card" style={{ background: "white", fontSize:'12px' }}>
                  <div className="col">
                     <div className="row p-2">
                      <div className="icon-s"  style={{ marginLeft:'5px' }}>
                        <FontAwesomeIcon
                          icon={["fas", "truck"]}
                          className="icon"
                          style={{ color: "#067E99", padding:'5px' }}
                        />
                      </div>
                      <p className="p-2">Weekly Delivery Schedule</p>
                    </div>
                    <ResponsiveContainer width="100%" height="80%">
                        <BarChart data={this.state.graph}>
                          <CartesianGrid strokeDasharray="3 3" vertical={false} />
                          <XAxis dataKey="day" />
                          <YAxis
                            label={{
                              value: "No. of Delivery",
                              angle: -90,
                              position: "insideLeft",
                            }}
                          />
                          <Tooltip />
                          <Legend />
                        
                          <Bar dataKey="Scheduled" stackId="a" fill="#4287f5" />
                          <Bar dataKey="Accepted" stackId="a" fill="#56d160" />
                          <Bar dataKey="Rejected" stackId="a" fill="#fab7b4" />

                        </BarChart>
                      </ResponsiveContainer>
                  </div>
                </div>
                <div className="summary card" style={{ background: "white" }}>
                  <div>
                    <div className="d-flex justify-content-between">
                    <div className="row p-2">
                      <div className="icon-s ">
                        <FontAwesomeIcon
                          icon={["fas", "truck"]}
                          className="icon"
                          style={{ color: "#067E99", padding:'5px' }}
                        />
                      </div>
                      <p className="p-2">Summary</p>
                    </div>
                    <select
                              className="form-control" style={{width:'130px', paddingBottom:'0px', paddingTop:'0px'}}
                              value={this.state.selectedStatus}
                              onChange={(e) =>
                                this.setState({ selectedStatus: e.target.value }, () =>
                                  this.fetchDashboardDataGraph()
                                )
                              }
                            >
                              {statusOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p></p> <p>₹ {Math.ceil(this.state.delivery)} /-</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p></p>  <p style={{ fontSize: "20px", color: "gray" }}>
                          Earned Amount
                        </p>
                    </div>
                    <hr />
                   
                    <div className="d-flex justify-content-between">
                      <p>Quotation</p>{" "}
                      <p>{Math.ceil(this.state.quotationCost)} ₹</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Purchase Order</p>{" "}
                      <p>{Math.ceil(this.state.purchaseOrderCost)} ₹</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Bill Amount</p> <p>{Math.ceil(this.state.delivery)} ₹</p>
                    </div>
                    

                   
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  iidArray: store.RouteMenuReducer.assignedIIDArray,
  iidDetails: store.RouteMenuReducer.assignedIIDDetails,
});

export default connect(mapStateToProps)(VendorDashboard);
